<template>
<div class="signUp1-wrap">
    <div class="signUp1">
        <div class="signUp1-header">
            <p>请核对您的订单信息</p>
        </div>
        <div class="signUp1-content">
            <div class="activity-title ordeitem">
                <span class="name">商品名称</span>
                <span>:</span>
                <span class="one">{{submitInfo.car_name}}</span>
            </div>
            <div class="activity-img ordeitem">
                <img :src="submitInfo.photo" alt="">
            </div>
            <div class="order-id ordeitem">
                <span class="name">订单号</span>
                <span>:</span>
                <span class="one">{{submitInfo.order_num}}</span>
            </div>
            <div class="activity-id ordeitem">
                <span class="name">活动名称</span>
                <span>:</span>
                <span class="one">{{submitInfo.action_name}}</span>
            </div>
            <div class="order-price ordeitem">
                <span class="name">报名费</span>
                <span>:</span>
                <span class="one">{{submitInfo.order_price}}元</span>
            </div>
            <div class="order-time ordeitem">
                <span class="name">下单时间</span>
                <span>:</span>
                <span class="one">{{submitInfo.time}}</span>
            </div>
            <div class="order-state ordeitem">
                <span class="name">订单状态</span>
                <span>:</span>
                <span class="one">{{submitInfo.stateN}}</span>
            </div>
            <div class="user-name ordeitem">
                <span class="name">用户名</span>
                <span>:</span>
                <span class="one">{{submitInfo.uname}}</span>
            </div>
            <div class="user-phone ordeitem">
                <span class="name">手机号</span>
                <span>:</span>
                <span class="one">{{submitInfo.tell}}</span>
            </div>
        </div>
        <div class="signUp1-footer">
            <el-button type="danger" @click="gotoPay">去支付</el-button>
        </div>
    </div>
</div>
</template>

<script>
// import BScroll from 'better-scroll'
import PubSub from 'pubsub-js';
import {
    wexinPay
} from "@/WxPay/WxPay"
export default {
    name: 'SignUp1',
    data() {
        return {
            submitInfo: {},
            orderNum: ''
        }
    },
    beforeCreate() {

        // window.addEventListener("beforeunload", () => {
        //   sessionStorage.setItem("submitInfo", JSON.stringify(this.$options.submitInfo))
        // })
    },
    // destroyed() {
    //   sessionStorage.removeItem("submitInfo");
    // },
    async created() {
        this.orderNum = this.$route.params.id;
        // this.$options.submitInfo = sessionStorage.getItem("submitInfo") ? JSON.parse(sessionStorage.getItem("submitInfo")) : this.$options.submitInfo;

        // this.$bus.$on('submitInfo', (data) => {
        //   this.submitInfo = data;
        //   this.ordernum = data.order_num;
        // })
        const result = await this.$http.signUp.getOrderInfoByID({
            ordernum: this.orderNum
        })
        if (result.code === 200) {
            let state = {
                0: '待支付',
                1: '支付成功',
                3: '退款成功'
            }
            this.submitInfo = result.data;
            this.submitInfo.stateN = state[result.data.state];
        } else {
            this.$message({
                message: result.msg,
                type: 'error',
                center: true
            })
            return
        }
        // setTimeout(() => {
        //   this.$nextTick(() => {
        //     new BScroll(this.$refs.signUp1, {
        //       scrollY: true,
        //       click: true,
        //       probeType: 3,
        //       pullUpLoad: {
        //         threshold: -50, // 在上拉到超过底部 20px 时，触发 pullingUp 事件
        //         stop: 20
        //       },
        //     })
        //   })
        // }, 500)
    },
    mounted() {
        this.orderNum = this.$route.params.id;
    },
    methods: {
        gotoPay() {

            // const result = await this.$http.signUp.getWechatConfig({
            //   // url: document.domain
            //   url: 'http://h5.jingcaicheshi.com'
            // });
            // console.log(result.data)
            this.$http.signUp.getWechatConfig({
                // url: document.domain
                url: 'https://jingcaicheshi.com',
                ordernum: this.orderNum
            }).then(res => {
                wexinPay(res.data).then(res => {

                    window.location.href = `https://jingcaicheshi.com/#/myorder`;
                    this.$message({
                        message: '支付成功!',
                        type: 'success',
                        center: true,
                        offset: 130
                    })
                }).catch(err => {
                    this.$message({
                        message: '支付失败!',
                        type: 'error',
                        center: true,
                        offset: 130
                    })
                })
            })

        }
    }
}
</script>

<style lang="less">
.signUp1-wrap {
    height: 100vh;
    position: relative;

    .signUp1 {

        .signUp1-header {
            font-size: 50px;
            color: #f04848;
            text-align: center;
            height: 60px;
            line-height: 60px;
            margin-top: 10px;
            margin-bottom: 20px;
        }

        .signUp1-content {
            padding: 0 30px;
            font-size: 34px;

            .ordeitem {
                margin-bottom: 20px;

                .one {
                    margin-left: 20px;
                }

                .name {
                    display: inline-block;
                    width: 150px;
                }

                img {
                    width: 500px;
                }
            }

            .order-price {
                .one {
                    color: red;
                    font-size: 38px;
                }
            }

        }

        .signUp1-footer {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 40px;

            .el-button {
                width: 200px;
                height: 80px;
                font-size: 40px;
            }
        }
    }
}
</style>
